/**
 * Hook to fetch and manage Custom GPT list
 */

import { useState, useEffect } from 'react'
import { getCustomGPTs } from '../../../lib/api/customGPT'
import type { CustomGPT } from '../../../types/custom-gpt'

export function useCustomGPTs(page: number = 1, limit: number = 20) {
  const [gpts, setGpts] = useState<CustomGPT[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [total, setTotal] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  useEffect(() => {
    let cancelled = false

    async function fetchGPTs() {
      setLoading(true)
      setError(null)

      try {
        const response = await getCustomGPTs(page, limit)
        
        if (!cancelled) {
          setGpts(response.items)
          setTotal(response.total)
          setTotalPages(response.total_pages)
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to fetch Custom GPTs')
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    fetchGPTs()

    return () => {
      cancelled = true
    }
  }, [page, limit])

  return {
    gpts,
    loading,
    error,
    total,
    totalPages,
    refetch: () => {
      setLoading(true)
      getCustomGPTs(page, limit)
        .then((response) => {
          setGpts(response.items)
          setTotal(response.total)
          setTotalPages(response.total_pages)
          setLoading(false)
        })
        .catch((err) => {
          setError(err instanceof Error ? err.message : 'Failed to fetch Custom GPTs')
          setLoading(false)
        })
    },
  }
}

